import workspaceQuery from '../../../graphql/queries/product/ProductCategoryAttributeConfigWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/ProductCategoryAttributeConfigListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/ProductCategoryAttributeConfigQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/ProductCategoryAttributeConfigDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/ProductCategoryAttributeConfigMutation.graphql';
import fragment from '../../../graphql/fragments/product/ProductCategoryAttributeConfigFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const ProductCategoryAttributeConfig: EntityType = {
  type: 'ProductCategoryAttributeConfig',
  title: 'Product Category Attributes',
  formTitle: 'Product Category Attribute',
  formUrl: '/Category/AttributeConfig/Details/',
  workspaceUrl: '/Category/AttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'PRODUCTS_CATEGORY_ATTRIBUTES',
};

export default ProductCategoryAttributeConfig;
